// @flow
'use strict';

import CamposNfe from './campos_nfe';

export default CamposNfe;